//Create an enum with the following values: SearchBar, Cart, ShopWithAiButton

export const EntryPoint = {
    SearchBar: 'Search Bar',
    Cart: 'Cart',
    ShopWithAiButton: 'Shop With AI Button',
    RespondingFromCartAssistant: 'Responding From Cart Assistant'
}